import React, {FC} from "react";
import {Card, CardContent, CardProps, Checkbox, Divider, FormControlLabel, Grid, Typography} from "@material-ui/core";
import {RoomService as ServiceIcon} from "@material-ui/icons";
import {WorkerServiceCheckbox} from "../../../services/components/WorkerServiceCheckbox";
import {Skeleton} from "@material-ui/lab";
import {useServices} from "../../../services/redux/services.hook";

const LoadingServiceCheckBox: FC = () => (
    <FormControlLabel
        disabled
        control={<Checkbox checked={false}/>}
        label={<Skeleton width={120}/>}
    />
);

interface WorkersCheckableServicesProps {
    workerId?: string;
    servicesIds?: string[];
    cardProps?: CardProps;
}

export const WorkersCheckableServices: FC<WorkersCheckableServicesProps> = ({workerId, servicesIds, cardProps}) => {
    const services = useServices();

    return (
        <Card {...cardProps}>
            <CardContent>
                <Typography
                    color="textSecondary"
                    style={{display: 'inline-flex', alignItems: 'center'}}
                >
                    Services<ServiceIcon color="inherit" fontSize="inherit" style={{marginLeft: 4}}/>
                </Typography>
                <Divider style={{marginBottom: 8, marginTop: 8}}/>
                <Grid container spacing={1}>
                    {!servicesIds && [...Array(9)].map((_v, i) =>
                        <LoadingServiceCheckBox
                            key={'loading-item-' + i}
                        />
                    )}
                    {workerId && servicesIds && (
                        services.filter((s) => s.active).map((service) => (
                            <Grid item xs={4} key={"serviceCheckbox-" + service.id}>
                                <WorkerServiceCheckbox
                                    workerId={workerId}
                                    service={service}
                                    checked={servicesIds.includes(service.id)}
                                />
                            </Grid>
                        )))
                    }
                </Grid>
            </CardContent>
        </Card>
    )
}